import { inject } from '@vercel/analytics'
import { ErrorBoundary } from '@sentry/react'
import { Toaster } from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'
import CoreLoading from './core/components/CoreLoading'
import ErrorHandler from './core/components/ErrorHandler/ErrorHandler'
import ErrorToastr from './core/components/ErrorHandler/ErrorToastr'
import useCrispChat from './core/hooks/useCrispChat'
import useFormValidationLocalization from './core/hooks/useFormValidationLocalization'
import Routes from './core/routes/Routes'
import NavigationPromptProvider from './shared/providers/NavigationPropmptProvider'
import RoutesTrackingProvider from './shared/providers/RoutesTrackingProvider'

const fallback = ({ error }: { error: Error }) => <ErrorHandler error={error} />

const App = () => {
  inject()
  useTranslation()
  useFormValidationLocalization()
  useCrispChat()

  return (
    <div>
      <BrowserRouter>
        <ErrorBoundary fallback={fallback}>
          <NavigationPromptProvider>
            <RoutesTrackingProvider>
              <Routes />
              <ErrorToastr />
            </RoutesTrackingProvider>
          </NavigationPromptProvider>
        </ErrorBoundary>
      </BrowserRouter>
      <Toaster reverseOrder />
      <CoreLoading />
    </div>
  )
}
export default App
